import { Flex, Heading, Text } from '@chakra-ui/react'

import NotFound from '@/components/Icons/NotFound'

type EmptyType = 'series or sessions' | 'sessions' | 'series'

export default function CourseResultsSingleEmpty({
  hasFilters,
  context = null,
  type = 'series or sessions',
}: {
  hasFilters: boolean
  context?: string | null
  type?: EmptyType
}): React.ReactElement {
  return (
    <Flex direction="column" align="center" textAlign="center" mt="8px" padding="24px">
      <NotFound />
      <Heading size="xl" as="h3">
        Oh no!
      </Heading>
      {hasFilters ? (
        <Text my="16px" maxWidth="500px">
          We couldn&apos;t find any upcoming {type}. Try changing your filter criteria, or request a
          future session.
        </Text>
      ) : (
        <Text my="16px" maxWidth="500px">
          We couldn’t find any upcoming {type}
          {context == null ? (
            ''
          ) : (
            <Text as="span">
              {' '}
              in{' '}
              <Text as="span" fontWeight={600}>
                {context}
              </Text>
            </Text>
          )}
          . Please check again later.
        </Text>
      )}
    </Flex>
  )
}
